module.exports = __webpack_public_path__ + "img/flot2.e502e430.svg";